var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBinanceSmartChain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#F0B90B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7996 15.8024L25.1379 11.6875L32.4775 15.8024L29.787 17.3255L25.1379 14.7269L20.4968 17.3255L17.7996 15.8024ZM32.4762 21.0007L29.7857 19.4763L25.1379 22.0762L20.4968 19.4763L17.7996 21.0007V24.0388L22.4326 26.6387V31.829L25.1379 33.3534L27.8364 31.829V26.64L32.4775 24.0402L32.4762 21.0007ZM32.4762 29.2386V26.1911L29.7857 27.7141V30.7536L32.4762 29.2386ZM34.3985 30.314L29.7574 32.9044V35.9519L37.0957 31.829V23.5993L34.3985 25.1156V30.314ZM31.7 18.4009L34.3904 19.9253V22.9634L37.0957 21.4484V18.4009L34.3985 16.8778L31.7 18.409V18.4009ZM22.4326 34.0108V37.0489L25.1379 38.5733L27.8364 37.0502V34.0162L25.1379 35.5352L22.4407 34.0108H22.4326ZM17.7996 29.2305L20.4901 30.7536V27.7155L17.7996 26.1911V29.2386V29.2305ZM22.4326 18.4009L25.1379 19.9253L27.8364 18.4009L25.1379 16.8778L22.4407 18.409L22.4326 18.4009ZM15.8786 19.9253L18.5758 18.4009L15.8853 16.8778L13.1814 18.409V21.4565L15.8786 22.9728V19.9253ZM15.8786 25.1156L13.1787 23.5993V31.829L20.5183 35.9519V32.8977L15.8853 30.3059V25.1076L15.8786 25.1156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceSmartChain);
export default __webpack_public_path__ + "static/media/Binance Smart Chain.44efe670d5e0a77faab9fce7fc316cfa.svg";
export { ForwardRef as ReactComponent };